"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var SuiteCalcCTAsContainer = function SuiteCalcCTAsContainer(props) {
  return _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/growth-suite-page/SuiteCalcAuthedCTAs");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/CalculatorPublicCTAs");
    },
    authedComponentProps: (0, _extends2.default)({}, props),
    publicComponentProps: {
      use: 'primary-white',
      nonMerchandiseIdProduct: "growth" + props.edition,
      sourceId: 'pricing-middle'
    }
  });
};

SuiteCalcCTAsContainer.propTypes = {
  edition: _propTypes.default.string.isRequired
};
var _default = SuiteCalcCTAsContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcCTAsContainer.js
// module id = 864
// module chunks = 5 6